type MediaQueryChangeHandler = (event: MediaQueryListEvent) => void;

type LegacyMediaQueryList = MediaQueryList & {
  addListener?: (listener: MediaQueryChangeHandler) => void;
  removeListener?: (listener: MediaQueryChangeHandler) => void;
};

export function addMQListener(
  mediaQueryList: MediaQueryList,
  listener: MediaQueryChangeHandler,
) {
  if (typeof mediaQueryList.addEventListener === "function") {
    mediaQueryList.addEventListener("change", listener);
    return;
  }

  const legacyMediaQueryList = mediaQueryList as LegacyMediaQueryList;
  legacyMediaQueryList.addListener?.(listener);
}

export function removeMQListener(
  mediaQueryList: MediaQueryList,
  listener: MediaQueryChangeHandler,
) {
  if (typeof mediaQueryList.removeEventListener === "function") {
    mediaQueryList.removeEventListener("change", listener);
    return;
  }

  const legacyMediaQueryList = mediaQueryList as LegacyMediaQueryList;
  legacyMediaQueryList.removeListener?.(listener);
}

export function subscribeToMediaQueryChange(
  mediaQueryList: MediaQueryList,
  listener: MediaQueryChangeHandler,
) {
  addMQListener(mediaQueryList, listener);
  return () => removeMQListener(mediaQueryList, listener);
}
